export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    fillRate: 'Fill Rate',
    errPercent: 'Err %',
    emptyPercent: 'Empty %'
};



// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/config.js